<script>
import { api } from "@/state/services";
import ModalPayment from "@/components/_jusbrasil/modal-payment";
import ModalDel from "@/components/_jusbrasil/modal-del";
import ModalDocumentsSend from "@/components/_jusbrasil/modal-documents-send";

export default {
  components: {
    ModalPayment,
    ModalDel,
    ModalDocumentsSend,
  },
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    client: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // Documentos e acesso do cliente ainda não estão liberados na interface
      documentsEnabled: true,

      documents: {
        loading: false,
        list: null,
        upload: {
          // Tipo de documento com upload em andamento — trava só a própria linha
          type: "",
        },
        send: {
          modal: false,
          type: "",
        },
      },

      payment: {
        modal: false,
      },

      del: {
        modal: false,
      },
    };
  },
  computed: {
    show: {
      get() {
        return this.modal;
      },
      set(value) {
        this.$emit("update:modal", value);
      },
    },
  },
  methods: {
    onShow() {
      if (!this.documentsEnabled) {
        return;
      }

      this.documents.list = null;
      this.documents.loading = false;
      this.getDocuments();
    },
    getDocuments() {
      this.documents.loading = true;
      api
        .get('jusbrasil/clients/documents/' + this.client.id)
        .then((response) => {
          if (response.data.status === 'success') {
            this.documents.list = response.data.documents;
          }
          this.documents.loading = false;
        })
        .catch(() => {
          this.documents.loading = false;
        });
    },
    triggerUpload(type) {
      this.$refs['fileInput_' + type][0].click();
    },
    uploadDocument(type, event) {
      const file = event.target.files[0];
      if (!file) return;
      this.documents.upload.type = type;
      const formData = new FormData();
      formData.append('file', file);
      api
        .post(`jusbrasil/clients/documents/upload/${this.client.id}/${type}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((response) => {
          if (response.data.status === 'success') {
            this.$toast.success('Documento enviado com sucesso!');
            this.getDocuments();
          } else {
            this.$toast.error(response.data.message);
          }
          this.documents.upload.type = '';
          event.target.value = '';
        })
        .catch(() => {
          this.documents.upload.type = '';
        });
    },
    copyLink(url) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url)
          .then(() => this.$toast.success('Link copiado!'))
          .catch(() => this.$toast.error('Não foi possível copiar.'));
      }
    },
    docLabel(type) {
      const labels = {
        ficha_associativa:   'Ficha Associativa',
        autorizacao_processo:'Autorização de Processo',
        contrato_social:     'Contrato Social',
        cartao_cnpj:         'Cartão CNPJ',
        doc_foto:            this.client.type == 'natural' ? 'Documento com Foto' : 'Documento com Foto do Sócio',
      };
      return labels[type] || type;
    },
    isSignType(type) {
      return ['ficha_associativa', 'autorizacao_processo'].includes(type);
    },
    // Envio liberado só antes da análise ou depois de reprovado pelo admin
    canUpload(status) {
      return ['pending', 'rejected'].includes(status);
    },
    // Força o ciclo false → true para o modal abrir mesmo se a flag ficou dessincronizada
    openModal(target) {
      target.modal = false;

      this.$nextTick(() => {
        target.modal = true;
      });
    },
    showPayment() {
      this.openModal(this.payment);
    },
    showDel() {
      this.openModal(this.del);
    },
    showSendDocument(type) {
      this.documents.send.type = type;
      this.openModal(this.documents.send);
    },
    onPaid() {
      this.show = false;
      this.$emit('reload');
    },
    onDeleted() {
      this.show = false;
      this.$emit('reload');
    },
  },
};
</script>

<template>
  <div>
    <b-modal v-model="show" title="Dados do Cliente" modal-class="modal-right" hide-footer @show="onShow">
      <div>
        <div class="mb-3"><strong class="font-size-12">Criado em {{ client.date_added }}</strong></div>
      </div>
      <template v-if="client.type == 'natural'">
        <div class="mb-3"><strong class="font-size-12">Nome</strong><br><span class="font-size-16">{{ client.name }}</span></div>
        <div class="mb-3"><strong class="font-size-12">CPF</strong><br><span class="font-size-16">{{ client.person_number }}</span></div>
      </template>
      <template v-else>
        <div class="mb-3"><strong class="font-size-12">Razão Social</strong><br><span class="font-size-16">{{ client.name }}</span></div>
        <div class="mb-3"><strong class="font-size-12">CNPJ</strong><br><span class="font-size-16">{{ client.person_number }}</span></div>
        <div class="mb-3"><strong class="font-size-12">Nome do Sócio</strong><br><span class="font-size-16">{{ client.company_partner_name }}</span></div>
        <div class="mb-3"><strong class="font-size-12">CPF do Sócio</strong><br><span class="font-size-16">{{ client.company_partner_cpf }}</span></div>
      </template>
      <div class="mb-3"><strong class="font-size-12">Email</strong><br><span class="font-size-16">{{ client.email }}</span></div>
      <div class="mb-3"><strong class="font-size-12">Celular</strong><br><span class="font-size-16">{{ client.cellphone }}</span></div>
      <div class="mb-3">
        <strong class="font-size-12">Status</strong><br>
        <span class="badge badge-soft-danger p-2 font-size-14" v-if="client.status == 'pending'">PENDENTE</span>
        <template v-else-if="client.status == 'approved'">
          <span class="badge badge-soft-success p-2 mb-1 mr-1 font-size-14">PAGO</span>
          <span class="font-size-14 text-center">{{ client.date_approved }}</span>
        </template>
      </div>
      <div class="mb-3" v-if="client.observations">
        <strong class="font-size-12">Observações</strong><br>
        <fieldset v-html="client.observations">
        </fieldset>
      </div>

      <div v-if="documentsEnabled" class="mb-3">
        <fieldset class="py-0">
          <legend>Documentos</legend>
          <div v-if="documents.loading" class="text-center py-3">
            <b-spinner variant="default" small role="status"></b-spinner>
          </div>
          <div v-else-if="documents.list">
            <div v-for="(doc, index) in documents.list" :key="index" class="d-flex align-items-center justify-content-between py-3" :class="index < documents.list.length - 1 ? 'border-bottom' : ''">
              <div>
                <div class="font-size-13">{{ docLabel(doc.type) }}</div>
                <span class="badge badge-soft-danger font-size-11"  v-if="doc.status === 'pending'">PENDENTE</span>
                <span class="badge badge-soft-info font-size-11"    v-else-if="doc.status === 'sent'">AGUARDANDO</span>
                <span class="badge badge-soft-success font-size-11" v-else-if="doc.status === 'signed'">ASSINADO</span>
                <span class="badge badge-soft-danger font-size-11"  v-else-if="doc.status === 'refused'">RECUSADO</span>
                <span class="badge badge-soft-warning font-size-11" v-else-if="doc.status === 'uploaded'">EM ANÁLISE</span>
                <span class="badge badge-soft-success font-size-11" v-else-if="doc.status === 'approved'">APROVADO</span>
                <span class="badge badge-soft-danger font-size-11"  v-else-if="doc.status === 'rejected'">REPROVADO</span>
                <div class="text-danger font-size-11 mt-1" v-if="doc.status === 'rejected' && doc.rejection_reason">
                  {{ doc.rejection_reason }}
                </div>
              </div>
              <div class="d-flex align-items-center flex-gap-5">
                <template v-if="!isSignType(doc.type)">
                  <template v-if="canUpload(doc.status)">
                    <input :ref="'fileInput_' + doc.type" type="file" :accept="'image/*,application/pdf'" capture="environment" style="display:none" v-on:change="uploadDocument(doc.type, $event)">
                    <button class="btn btn-sm btn-outline-default" :disabled="documents.upload.type === doc.type" v-on:click="triggerUpload(doc.type)">
                      {{ doc.status === 'rejected' ? 'Reenviar' : 'Enviar' }}
                    </button>
                  </template>
                </template>
                <template v-else>
                  <button v-if="doc.status === 'pending' || doc.status === 'refused'" class="btn btn-sm btn-outline-default" v-on:click="showSendDocument(doc.type)">
                    Gerar
                  </button>
                  <button v-if="doc.status === 'sent' && doc.sign_url" class="btn btn-sm btn-outline-secondary" v-on:click="copyLink(doc.sign_url)">
                    Copiar link
                  </button>
                </template>
              </div>
            </div>
          </div>
        </fieldset>
      </div>

      <div class="mt-3">
        <button class="btn btn-success btn-lg btn-block" :disabled="client.status != 'pending'" v-on:click="showPayment()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor">
            <path
              d="M12 15c-1.84 0-2-.86-2-1H8c0 .92.66 2.55 3 2.92V18h2v-1.08c2-.34 3-1.63 3-2.92 0-1.12-.52-3-4-3-2 0-2-.63-2-1s.7-1 2-1 1.39.64 1.4 1h2A3 3 0 0 0 13 7.12V6h-2v1.09C9 7.42 8 8.71 8 10c0 1.12.52 3 4 3 2 0 2 .68 2 1s-.62 1-2 1z">
            </path>
            <path d="M5 2H2v2h2v17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4h2V2H5zm13 18H6V4h12z"></path>
          </svg>
          Realizar Pagamento
        </button>
      </div>
      <div class="mt-3">
        <button class="btn btn-danger btn-lg btn-block" :disabled="client.status != 'pending'" v-on:click="showDel()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor">
            <path d="M5 20a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8h2V6h-4V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H3v2h2zM9 4h6v2H9zM8 8h9v12H7V8z"></path>
            <path d="M9 10h2v8H9zm4 0h2v8h-2z"></path>
          </svg>
          Excluir Cliente
        </button>
      </div>
    </b-modal>

    <ModalPayment :modal.sync="payment.modal" :client="client" @paid="onPaid" />

    <ModalDel :modal.sync="del.modal" :id="client.id" @deleted="onDeleted" />

    <ModalDocumentsSend :modal.sync="documents.send.modal" :client="client" :type="documents.send.type" @sent="getDocuments" />
  </div>
</template>

<style scoped>
button:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
</style>
